<template>
    <div v-show="visible">
        <el-dialog title="考勤状态编辑" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"  width="30%">    
            <el-form ref="form" :model="form" :rules="rules" label-width="100px"> 
                <el-form-item prop="status" label="状态">
                    <el-select v-model="form.status" placeholder="请选择">
                        <el-option
                            v-for="item in statuss"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../common/http';
    import {banBackSpace} from '../../../common/preventBackspace';// backspace退格

    export default {
        data(){
            return{
                visible: false,
                form:{
                    id:"",
                    type:"",
                    status:2
                },
                statuss: [{
                    value: 2,
                    label: '正常'
                }],
                rules: {
                    status: [
                        { required: true, message: '请选择状态', trigger: 'blur' }
                    ]
                }
            }
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(id,type){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id=id;
                this.form.type=type;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        let url= this.updateTeacherDayUrl;
                        let data = {
                            id:this.form.id,
                            type:this.form.type,
                            status:this.form.status
                        };
                        // console.log(JSON.stringify(data));
                        this.apiPost(url, data).then((res) => {
                            if(res.status == 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
   .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }  
</style>


// WEBPACK FOOTER //
// src/components/page/count/Add.vue